import * as nodePath from 'node:path';
import type { Dirent, FileMap } from '.';
import { WORK_DIR } from '~/utils/constants';

export function writeDirentRecursively(files: FileMap, fullPath: string, value: Dirent) {
  let parentDir = fullPath;

  while ((parentDir = nodePath.dirname(parentDir)) !== WORK_DIR) {
    if (files[parentDir]) {
      break;
    }

    files[parentDir] = { type: 'folder', isLocked: false, isTargeted: false };
  }

  files[fullPath] = value;
}
